import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS, DICTIONARIES, ERRORS } from 'utils/constants';
import { fDateTime, validateDates } from 'utils/formatTime';

//
import API from 'restApi';
import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  dictionaries: [],
  dictionary: null,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },

  filters: {
    dictionaryType: DICTIONARIES[1],
    code: '',
    label: '',
    accessLevel: '',
    visibility: [],
    bacterio: null,
    orderByColumn: 'code',
    orderByType: 'ASC',
    lastUpdateFrom: null,
    lastUpdateTo: null,

  },

};

const slice = createSlice({
  name: 'dictionary',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;

    },

    // reset dictionary
    resetDictionary(state) {
      state.dictionary = initialState.dictionary;
    },

    // GET Dictionary
    getDictionarySuccess(state, action) {
      const { dictionary } = action.payload;
      state.isLoading = false;
      state.dictionary = dictionary;
      state.error = null;
    },

    // GET Dictionaries
    getDictionariesSuccess(state, action) {
      const { responses, navig } = action.payload;
      state.error = null;
      state.isLoading = false;
      state.dictionaries = responses;
      state.navig = navig;
    },

    //  SORT & FILTER Dictionary
    sortByDictionaries(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FILTER Dictionary
    paginationDictionaries(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    sortDictionaries(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    filterDictionary(state, action) {
      state.filters = action.payload;
    },

    resetDictionariesLight(state) {
      state.dictionaries = initialState.dictionaries;
      state.filters = initialState.filters;
    },

    resetDictionaries(state) {
      state.dictionaries = initialState.dictionaries;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  paginationDictionaries,
  filterDictionary,
  hasError,
  resetDictionaries,
  sortDictionaries,
  resetDictionary,
  resetDictionariesLight
} = slice.actions;

// ----------------------------------------------------------------------

export function getDictionaries() {
  const { dictionary: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const start = new Date(filters.lastUpdateFrom).getTime();
      const end = new Date(filters.lastUpdateTo).getTime();
      const errors = validateDates({ start, end });
      const regex = /^[0-9]$/;
      if (!regex.test(filters.accessLevel) && filters.accessLevel !== null && filters.accessLevel.trim() !== "") {
        errors.NUMBER_REQUIRED = ERRORS.numberRequired;
      }
      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      // Fixer lastUpdateTo à 23h59
      const lastUpdateTo = filters.lastUpdateTo ? new Date(new Date(filters.lastUpdateTo).setHours(23, 59, 59)).toISOString() : null;

      const criteres = {
        ...filters,
        bacterio: filters.bacterio ? filters.bacterio.code === "O" : null,
        lastUpdateFrom: filters.lastUpdateFrom ? fDateTime(filters.lastUpdateFrom) : '',
        lastUpdateTo: filters.lastUpdateTo ? fDateTime(lastUpdateTo) : '',
        visibility: filters.visibility.map((item) => item.code)
      };
      let action = ACTIONS.SEARCHDICOCHAPTERS;
      if (filters.dictionaryType.code === DICTIONARIES[1].code)
        action = ACTIONS.SEARCHDICOEXAMS;
      if (filters.dictionaryType.code === DICTIONARIES[2].code)
        action = ACTIONS.SEARCHDICOANALYSIS;

      const response = await axios.post(API.path, {
        criteres,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },

        action
      });

      const { data } = response;
      if (data.statut === "OK") {
        dispatch(slice.actions.getDictionariesSuccess(data));

        if (data.responses.length === 0) {
          if (filters.dictionaryType.code === DICTIONARIES[1].code)
            throw new Error('NO_EXAM_RESULTS');
          if (filters.dictionaryType.code === DICTIONARIES[2].code)
            throw new Error('NO_ANALYSE_RESULTS');
          throw new Error('NO_CHAPTER_RESULTS');
        }

      }


    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}

export function getExam({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADEXAMINFOS,
        criteres: {
          examCode: code
        }
      });

      const { data: { exam } } = response;
      dispatch(slice.actions.getDictionarySuccess({ dictionary: exam }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getChapter({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADCHAPTERINFOS,
        criteres: {
          chapterCode: code
        }
      });

      const { data: { chapter } } = response;
      dispatch(slice.actions.getDictionarySuccess({ dictionary: chapter }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
} export function getAnalysis({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADANALYSISINFOS,
        criteres: {
          analysisCode: code
        }
      });

      const { data: { analysis } } = response;
      dispatch(slice.actions.getDictionarySuccess({ dictionary: analysis }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}



